import React from 'react';
import Navigation from '../components/Navigation';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const FAQPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Frequently Asked Questions" description="Answers to common questions about mental health services at SDORA Wellbeing. What is PRP? Does Medicaid cover therapy? How to get started with OMHC or PRP in Pikesville, MD." path="/faq" />
      <Navigation />
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Find answers to common questions about our services, therapy sessions, insurance, and getting started.
          </p>
        </div>
      </div>

      <FAQSection />
      <Footer />
    </div>
  );
};

export default FAQPage;